package com.exura.components.layouts.nav

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.setValue
import com.exura.components.icons.UntiledIcon
import com.exura.features.localization.commonLocalization
import com.exura.ui.Assets
import com.varabyte.kobweb.silk.theme.colors.ColorMode

@Composable
internal fun NavigationScope.ThemeToggle() {
    var colorMode by ColorMode.currentState

    NavigationButton(
        text = if (colorMode.isLight) commonLocalization.current.nav.lightMode
            else commonLocalization.current.nav.darkMode,
        onClick = { colorMode = if (colorMode.isLight) ColorMode.DARK else ColorMode.LIGHT },
        variant = NavNavigableElementWarnVariant,
    ) {
        if (colorMode.isLight) {
            UntiledIcon(Assets.IconsUntiled.NAV_LIGHT_MODE)
        } else {
            UntiledIcon(Assets.IconsUntiled.NAV_DARK_MODE)
        }
    }

}
